export const CONTACT = {
  phones: [
    {
      id: "sa",
      tag: "South Africa line",
      label: "+27 84 039 4579",
      tel: "tel:+27840394579",
      wa: "https://wa.me/27840394579",
    },
    {
      id: "zw",
      tag: "Zimbabwe line",
      label: "+263 78 707 7284",
      tel: "tel:+263787077284",
      wa: "https://wa.me/263787077284",
    },
  ],
  email: "info@tuskersgrey.com",
  location: "Midlands Province, Zimbabwe",
  holdings: "https://tuskersgrey.com",
};

export const waLink = (wa, text) => `${wa}?text=${encodeURIComponent(text)}`;

export const MINERALS = [
  {
    id: "gold",
    name: "Gold",
    symbol: "Au",
    tagline: "Alluvial & reef parcels",
    image: "/assets/img/gold.jpg",
    description:
      "Alluvial and reef gold from registered Midlands producers — assay-verified parcels with full provenance, ready for formal buyers and refineries.",
    specs: ["Assay-verified parcels", "Full provenance documents", "Refinery-ready delivery"],
  },
  {
    id: "chrome",
    name: "Chrome",
    symbol: "Cr",
    tagline: "Metallurgical-grade chromite",
    image: "/assets/img/chrome.jpg",
    description:
      "Lumpy and concentrate chromite from the Great Dyke's rich seams, graded for furnace and export markets along the Beira and Durban corridors.",
    specs: ["Lumpy & concentrate", "Cr2O3 grades on assay", "Export-corridor ready"],
  },
  {
    id: "lithium",
    name: "Lithium",
    symbol: "Li",
    tagline: "Spodumene & petalite",
    image: "/assets/img/lithium.jpg",
    description:
      "Spodumene and petalite concentrates feeding the battery supply chain — sampled, graded and verified before a single tonne moves.",
    specs: ["Battery-supply grades", "Independent sampling", "Containerised export"],
  },
  {
    id: "pgms",
    name: "PGMs",
    symbol: "Pt",
    tagline: "Platinum group metals",
    image: "/assets/img/pgms.jpg",
    description:
      "Platinum, palladium and companion metals from the Great Dyke — brokered with discretion and an unbroken chain of custody.",
    specs: ["Pt, Pd & companions", "Chain-of-custody handling", "Discreet settlement"],
  },
  {
    id: "nickel",
    name: "Nickel",
    symbol: "Ni",
    tagline: "Sulphide concentrates",
    image: "/assets/img/nickel.jpg",
    description:
      "Nickel sulphide concentrates from established Midlands operations, matched precisely to smelter and refinery specifications.",
    specs: ["Smelter-spec matching", "Consistent tonnage", "Certified assays"],
  },
  {
    id: "iron",
    name: "Iron Ore",
    symbol: "Fe",
    tagline: "High-grade hematite",
    image: "/assets/img/iron.jpg",
    description:
      "High-grade hematite lump and fines, crushed and screened to buyer specification for regional mills and seaborne trade.",
    specs: ["Lump & fines", "Screened to spec", "Regional & seaborne"],
  },
];

export const SERVICES = [
  {
    n: "01",
    id: "brokerage",
    title: "Mineral Brokerage",
    image: "/assets/img/pgms.jpg",
    description:
      "We represent producers at the negotiating table — sourcing credible buyers, structuring spot and offtake deals, and protecting our clients' margins from pit to payment.",
    points: ["Buyer sourcing & vetting", "Spot & offtake structuring", "Negotiation & mandate management"],
  },
  {
    n: "02",
    id: "logistics",
    title: "Logistics & Export",
    image: "/assets/img/plant.jpg",
    description:
      "Road, rail and port coordination from the Midlands to Beira, Durban and beyond. Permits, clearing and documentation managed end to end.",
    points: ["Mine-to-port coordination", "Export permits & clearing", "Beira & Durban corridors"],
  },
  {
    n: "03",
    id: "assaying",
    title: "Assaying & Verification",
    image: "/assets/img/gold.jpg",
    description:
      "Independent sampling and laboratory coordination, so both sides trade on certified numbers — no surprises at the weighbridge.",
    points: ["Independent sampling", "Accredited lab coordination", "Certificates with every parcel"],
  },
];

export const MANIFESTO = [
  {
    n: "01",
    title: "We stand at the source",
    body: "Based in the Midlands — the heart of Zimbabwe's Great Dyke — we work face to face with the miners who bring wealth out of the ground.",
  },
  {
    n: "02",
    title: "We verify before we broker",
    body: "Every parcel is sampled and assayed before it is offered. Our buyers trade on certified numbers, never on promises.",
  },
  {
    n: "03",
    title: "We deliver to the world",
    body: "From pit to port, we manage the paperwork, the permits and the passage — moving Midlands minerals into global markets.",
  },
];

export const PROCESS = [
  { n: "01", title: "Enquiry & mandate", body: "Tell us the mineral, grade and tonnage you need — or the parcel you hold." },
  { n: "02", title: "Sampling & assay", body: "Independent sampling and accredited lab verification before any commitment." },
  { n: "03", title: "Terms & contract", body: "Structured spot or offtake terms that protect both producer and buyer." },
  { n: "04", title: "Logistics & settlement", body: "Mine-to-port delivery with documentation, clearing and clean settlement." },
];

export const STATS = [
  { value: "06", label: "Core minerals brokered" },
  { value: "02", label: "Export corridors — Beira & Durban" },
  { value: "100%", label: "Assay-verified parcels" },
  { value: "24h", label: "Response on every enquiry" },
];
